import React from "react";
import { Container, Popover, OverlayTrigger, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// `faTiktok` ships in the free brands package from Font Awesome 5.13 onward and
// this app is on ^6.6.0, so TikTok needs no inline SVG here. The public web
// footer does need one, because it draws from @material-ui/icons and Material
// Design carries no third-party brand marks.
import {
  faFacebook,
  faGooglePlay,
  faTiktok,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

function AdminFooter() {
  const today = new Date();
  const playStoreLink = "https://play.google.com/store/apps/details?id=com.suku.rider&pcampaignid=web_share";

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(playStoreLink)
      .then(() => toast.success("Link copied to clipboard!"))
      .catch((err) => console.error('Failed to copy link: ', err));
  };

  const handleWhatsAppShare = () => {
    const text = `Download the Lusuku Rider app from the Play Store: ${playStoreLink}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(whatsappUrl, '_blank');
  };

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        <Button variant="link" style={{ color: "#13678A" }} onClick={handleCopyToClipboard}>
          <FontAwesomeIcon icon={faClipboard} /> Copy Link
        </Button>
        <Button variant="link" style={{ color: "#25D366" }} onClick={handleWhatsAppShare}>
          <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp
        </Button>
      </Popover.Body>
    </Popover>
  );

  return (
    <footer className="footer">
      <Container fluid className="pl-4 ml-2">
        <nav>
          <ul className="footer-menu">
            <li>
              <a
                style={{ textDecoration: "none", color: "#289788" }}
                target="_blank"
                href="https://cs.lusuku.shop/"
                rel="noopener noreferrer"
              >
                Call Centre
              </a>
            </li>
            <li>
              <Link
                to="/vendorRegistration"
                style={{ textDecoration: "none", color: "#ff9999" }}
              >
                Vendor Registration
              </Link>
            </li>
            <li>
              <a
                style={{ textDecoration: "none", color: "#3b5998" }}
                target="_blank"
                href="https://www.facebook.com/lusuku.ug"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebook} /> Facebook
              </a>
            </li>
            <li>
              <a
                /* TikTok's primary brand colour is black. Its cyan is unreadable
                   on this white footer and its magenta would sit beside the
                   pink Vendor Registration link, so black is both the correct
                   mark colour and the one that stays legible next to its
                   neighbours. */
                style={{ textDecoration: "none", color: "#010101" }}
                target="_blank"
                href="https://www.tiktok.com/@lusuku_"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faTiktok} /> TikTok
              </a>
            </li>
            <li>
              <OverlayTrigger trigger="click" placement="top" overlay={popover} rootClose>
                <a
                  style={{ textDecoration: "none", color: "#34A853", cursor: "pointer" }}
                >
                  <FontAwesomeIcon icon={faGooglePlay} /> Rider App
                </a>
              </OverlayTrigger>
            </li>
          </ul>
          <p className="copyright text-center">
            <a
              style={{ textDecoration: "none" }}
              target="_blank"
              href="https://mmict.it/"
              rel="noopener noreferrer"
            >
              A product of MM-iCT
            </a>
            , {today.getFullYear()} ©
          </p>
        </nav>
      </Container>
    </footer>
  );
}

export default AdminFooter;
